<template >
  <nav class="w-full px-5 md:px-10 py-3 shadow gap-2 items-center sticky top-0 z-10 bg-white">
    <slot></slot>
  </nav>
</template>
<script>
export default {
  name: 'Navbar',
};
</script>
